import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { PETICIONES, CARGOS_VALIDOS } from 'src/app/core/utils/constants';
import { Representants } from 'src/app/core/entities/representants.model';
import { IsProveidor } from 'src/app/core/entities/isproveidor.model';
import { RolsExternal } from 'src/app/core/entities/rolsexternal.model';
import { PersonsByIdNumCtrlDig } from 'src/app/core/entities/personsByIdNumCtrlDig.model';
import { RepresentantsAOC } from 'src/app/core/entities/representantsaoc.model';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { RolsExternalService } from 'src/app/core/repositories/rolsexternal.service';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from 'src/app/core/utils/utils';
import * as _ from 'lodash';

@Injectable()
export class ValidService {

    isCif: boolean = false;
    isLicencias: boolean = false;
    isProveidor: IsProveidor = new IsProveidor();
    conexrepre: boolean = false;

    allRepresentants: Representants[] = new Array<Representants>();
    allPersons: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();

    allrepresentanteAOC: RepresentantsAOC[] = new Array<RepresentantsAOC>();
    rolexterno: RolsExternal = new RolsExternal();

    constructor(private repositoryService: RepositoryService,
                private dialog: MatDialog,
                private translateService: TranslateService,
                private rolsExternalService: RolsExternalService,
                private router: Router ) { }

    init(nif: string, carpeta: string): Observable<any> {
        console.log("Comprobar Valid");
        switch(carpeta){
            case "1": {
                this.isCif = Utils.validaCif(nif);
                let filtroCiud = new Array<RepresentantsAOC>();
                return forkJoin({
                    personaid : this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif),
                    repreAOC : this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentanteAOC + "/" + nif),
                    rolexterno: this.rolsExternalService.findByCode("FI4INTERNET")
                }).pipe(map(({ personaid, repreAOC, rolexterno }) => {
                    this.allPersons = _.cloneDeep(personaid.personsByIdNumCtrlDig);
                    this.conexrepre = _.cloneDeep(repreAOC.errorconexrepre);
                    filtroCiud = _.cloneDeep(repreAOC.representantsAOC);
                    this.rolexterno = rolexterno as RolsExternal;

                    if(this.conexrepre){
                        this.errorCargaWS('WARNINGS.error_conex_aoc');
                    }

                    let isCifCiud: boolean;

                    if(filtroCiud != null && filtroCiud.length > 0){
                        for (let i = 0; i < filtroCiud.length; i++) {

                            isCifCiud = Utils.validaCif(filtroCiud[i].poderdantdocident);
                
                            if(!isCifCiud){
                                this.allrepresentanteAOC.push(filtroCiud[i]);
                            }
                        }
                    }

                }),catchError((error: any) => {
                    this.errorCargaWSNunIdent('WARNINGS.error_ws', nif);
                    this.router.navigate(['/external/passarela/acces']);
                    console.log(error);
                    throw error;
                }));
            }
            case "2": {
                this.isCif = Utils.isCifEmpresa3(nif);
                let filtroEmpre = new Array<RepresentantsAOC>();
                if(!this.isCif){
                    return forkJoin({
                        representantes: this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentants + "/" + nif),
                        personaid: this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif),
                        actividad: this.repositoryService.doGet(PETICIONES.webservice.doGetActividad + "/" + nif),
                        reprempresa: this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentaEmpresas + "/" + nif),
                        rolexterno: this.rolsExternalService.findByCode("FI4EMPRESA")
                    }).pipe(map(({ representantes, personaid, actividad, reprempresa, rolexterno }) => {
                        this.allRepresentants = _.cloneDeep(representantes.representants);
                        this.allPersons = _.cloneDeep(personaid.personsByIdNumCtrlDig);
                        this.isLicencias = _.cloneDeep(actividad);
                        this.conexrepre = _.cloneDeep(reprempresa.errorconexrepre);
                        filtroEmpre = _.cloneDeep(reprempresa.representantsAOC);
                        this.rolexterno = rolexterno as RolsExternal;

                        if(this.conexrepre){
                            this.errorCargaWS('WARNINGS.error_conex_aoc');
                        }

                        if(this.allRepresentants != null){
                            for(let i = 0; i < this.allRepresentants.length; i++){
                                if(this.allRepresentants[i].carrecnom !=  CARGOS_VALIDOS.PRESI || this.allRepresentants[i].carrecnom !=  CARGOS_VALIDOS.SECRE){
                                this.allRepresentants.splice(i, 1);
                                }
                            }
                        }

                        let isCifEmpre: boolean;

                        if(filtroEmpre != null && filtroEmpre.length > 0){
                            for (let i = 0; i < filtroEmpre.length; i++) {

                                isCifEmpre = Utils.validaCif(filtroEmpre[i].poderdantdocident);
                    
                                if(isCifEmpre || filtroEmpre[i].licencia){
                                    this.allrepresentanteAOC.push(filtroEmpre[i]);
                                }
                            }
                        }

                    }),catchError((error: any) => {
                        this.errorCargaWSNunIdent('WARNINGS.error_ws', nif);
                        this.router.navigate(['/external/empreses/acces']);
                        console.log(error);
                        throw error;
                    }));
                }else{
                    return forkJoin({
                        representantes: this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentants + "/" + nif),
                        personaid: this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif),
                        reprempresa: this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentaEmpresas + "/" + nif),
                        rolexterno: this.rolsExternalService.findByCode("FI4EMPRESA")
                    }).pipe(map(({ representantes, personaid, reprempresa, rolexterno }) => {
                        this.allRepresentants = _.cloneDeep(representantes.representants);
                        this.allPersons = _.cloneDeep(personaid.personsByIdNumCtrlDig);
                        this.conexrepre = _.cloneDeep(reprempresa.errorconexrepre);
                        this.allrepresentanteAOC = _.cloneDeep(reprempresa.representantsAOC);
                        this.rolexterno = rolexterno as RolsExternal;

                        if(this.conexrepre){
                            this.errorCargaWS('WARNINGS.error_conex_aoc');
                        }

                        if(this.allRepresentants != null){
                            for(let i = 0; i < this.allRepresentants.length; i++){
                                if(this.allRepresentants[i].carrecnom !=  CARGOS_VALIDOS.PRESI || this.allRepresentants[i].carrecnom !=  CARGOS_VALIDOS.SECRE){
                                this.allRepresentants.splice(i, 1);
                                }
                            }
                        }

                        let isCifEmpre: boolean;

                        if(filtroEmpre != null && filtroEmpre.length > 0){
                            for (let i = 0; i < filtroEmpre.length; i++) {

                                isCifEmpre = Utils.validaCif(filtroEmpre[i].poderdantdocident);
                    
                                if(isCifEmpre || filtroEmpre[i].licencia){
                                    this.allrepresentanteAOC.push(filtroEmpre[i]);
                                }
                            }
                        }

                    }),catchError((error: any) => {
                        this.errorCargaWSNunIdent('WARNINGS.error_ws',nif);
                        this.router.navigate(['/external/empreses/acces']);
                        console.log(error);
                        throw error;
                    }));
                }
            }
            case "3": {
                return forkJoin({
                    personaid: this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif),
                    proveedores: this.repositoryService.doGet(PETICIONES.webservice.doGetProveidors + "/" + nif),
                    repreprovee: this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentaProveidors + "/" + nif),
                    rolexterno: this.rolsExternalService.findByCode("FI4PROVEIDOR")
                }).pipe(map(({ personaid, proveedores, repreprovee, rolexterno }) => {
                        this.allPersons = _.cloneDeep(personaid.personsByIdNumCtrlDig);
                        this.isProveidor = _.cloneDeep(proveedores);
                        this.conexrepre = _.cloneDeep(repreprovee.errorconexrepre);
                        this.allrepresentanteAOC = _.cloneDeep(repreprovee.representantsAOC);
                        this.rolexterno = rolexterno as RolsExternal;

                        if(this.conexrepre){
                            this.errorCargaWS('WARNINGS.error_conex_aoc');
                        }   
                }),catchError((error: any) => {
                    this.errorCargaWSNunIdent('WARNINGS.error_ws', nif);
                    this.router.navigate(['/external/proveidors/acces']);
                    console.log(error);
                    throw error;
                }));
            }
            default:
                return throwError(() => new Error('Carpeta no válida'));
            }
    }

    /**
    * @description
    * Abre un cuadro de dialogo para informar de un error
    * @param error Texto a mostrar
    */
    public errorCargaWS(error: any) {
        setTimeout(() => {
            const dialogRef = this.dialog.open(DialogsAlertComponent, {
                disableClose: true,
                hasBackdrop: true,
                data: { texto: this.translateService.instant(error) }
            });
            dialogRef.afterClosed().subscribe(result => {
                console.log(result);
            });
        }, 500);
    }

    /**
    * @description
    * Abre un cuadro de dialogo para informar de un error con el num ident del usuario
    * @param error Texto a mostrar
    * @param num numero de identificacion del usuario
    */
    public errorCargaWSNunIdent(error: string, num: string) {
        let errortrad = this.translateService.instant(error);
        let infotexto = errortrad + ". NUM IDENT: " + num.bold();
        setTimeout(() => {
            const dialogRef = this.dialog.open(DialogsAlertComponent, {
                disableClose: true,
                hasBackdrop: true,
                data: { texto: infotexto }
            });
            dialogRef.afterClosed().subscribe(result => {
                console.log(result);
            });
        }, 500);
    }

    build() {}
}